// Round-robin generation: every player in a group meets every other player once.

/** All unordered pairings of `players`, in stable (i < j) order. */
export function roundRobinPairs<T>(players: readonly T[]): Array<[T, T]> {
  const pairs: Array<[T, T]> = [];
  for (let i = 0; i < players.length; i++) {
    for (let j = i + 1; j < players.length; j++) {
      pairs.push([players[i], players[j]]);
    }
  }
  return pairs;
}

/** Number of matches in a round-robin of `n` players: C(n, 2). */
export function roundRobinMatchCount(n: number): number {
  return (n * (n - 1)) / 2;
}
